$( document ).ready(function () {
  


 $('.footer-block.grid__item h2').click(function(){
      $(this).parent().find('.footer-block__details-content').slideToggle(280);
       $(this).parent().find('.footer-block__heading_icons-chevron').toggleClass('footer-icon-move');
      });


if ( $(window).width() < 1200 ) {

$('.itg_main_wrapper ').addClass('swiper-wrapper');
$('.itg_main_wrapper li').removeClass('grid__item');
$('.itg_main_wrapper ').removeClass('main_logos_block');
$('.itg_main_wrapper ').removeClass('main_logos');



  
var swiper = new Swiper(".itg_featured_multi_slider", {
  slidesPerView: 3,
  centeredSlides: false,
  autoplay:true,
  loop: true,
  spaceBetween: 0,
  slideToClickedSlide: true,
  watchSlidesVisibility: true,
  scrollbar: {
    el: ".itg_collection_scrollbar",
    hide: false,
    draggable: true,
  },
 
  breakpoints: {
    1025: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    767: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
     480: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    320: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
});

}

if ( $(window).width() < 991 ) {

$('.itg_featured_collection_wrapper ').addClass('swiper-wrapper');
$('.itg_featured_collection_wrapper li').removeClass('grid__item');  

var swiper = new Swiper(".itg_featured_collection_slider", {
  centeredSlides: false,
  slidesPerView: 1,
  autoplay:true,
  loop: false,
  spaceBetween: 10,
  slideToClickedSlide: false,
  watchSlidesVisibility: false,
  autoplay: {
   delay: 3000,
 },
  scrollbar: {
    el: ".itg_collection_scrollbar_featured",
    draggable: true,
    },
 
  breakpoints: {
    991: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
        spaceBetween: 10,
    },
    640: {
      slidesPerView: 2,
        spaceBetween: 20,
    },
     480: {
      slidesPerView: 2,
        spaceBetween: 20,
    },
    320: {
       slidesPerView: 2,
        spaceBetween: 20,
    },
  },
});
}



$('.header__menu-item span').on( "click", function(){
  $(this).parents('.mega-menu').find('.box_show_main_li').hide();
   $(this).parents('.mega-menu').find('.box_show_main').show();


});
  
  
$('.mega-menu__list .mega_menusimg_hover a').mouseover(function(){
 //alert();  
  $(this).closest('.mega-menu__list').find('.box_show_main').hide();
    $(this).closest('.mega-menu__list').find('.box_show_main_li').show();

  var image_src_li= $(this).parents('.mega_menusimg_hover').find('.products_header_li img').attr('src');
   //console.log(image_sr);
  var collection_url_li = $(this).attr('href');
   //console.log(collection_url);
  $(this).closest('.mega-menu__content').find('.itg_mega_menus_image.menus_images img').attr("src", image_src_li);
  $('.itg_mega_menus_image.menus_images a').attr("href", collection_url_li);

});
  

$('.mega-menu__list .mega_menusimg_hover .grand_child_hover').mouseover(function(){
   $(this).closest('.mega-menu__list').find('.box_show_main').hide();
    $(this).closest('.mega-menu__list').find('.box_show_main_li').show()
 //alert();  
  var image_src = $(this).find('.products_header .menu_products img').attr('src');
   //console.log(image_sr);
  var collection_url = $(this).find('a').attr('href');
   //console.log(collection_url);
  $(this).closest('.mega-menu__content').find('.itg_mega_menus_image.menus_images img').attr("src", image_src);
   $('.itg_mega_menus_image.menus_images a').attr("href", collection_url);

});

 $(".itg_product_tabs ul.tabs li a").click(function(){
      var a = $(this).attr('data-href');
      
       $('.itg_product_tabs ul.tabs li').removeClass('active_tab');  
       $(this).closest('.itg_product_tabs ul.tabs li').addClass('active_tab');  
       
    $('.product_content .product_data').each(function(){
        var b = $(this).attr('data-part');
        
        if(a == b){
         $(this).addClass('active_tab');
         
        }else{
          $(this).removeClass('active_tab');
         
        }
      });
    });

  // fancy box slider

// $().fancybox({
//   selector : '.slick-slide:not(.slick-cloned)',
//   hash     : false
// });

//    $(".fancy_image_slider").slick({
//   slidesToShow   : 3,
//   slidesToScroll : 3,
//   infinite : true,
//   dots     : false,
//   arrows   : false,
//   responsive : [
//     {
//       breakpoint : 960,
//       settings : {
//         slidesToShow   : 1,
//         slidesToScroll : 1
//       }
//     }
//   ]
// });

// $('.fancyimage img').click(function(){
//   alert();
// });

   $('.type_selection_other').on('change',function () {
      var selval = $(this).find(":selected").attr('data-val');
       $(this).closest('.product-form__input').find("label.itg_option_other").each(function () {
         var thslabel = $(this).attr('data-value');
         if(thslabel == selval){
            $(this).click();
            $(this).addClass('ddddd');
          }
       }); 
   });


  // blog tag fillter js start

    $('select.tag-filter').on('change', function () {
       var selectedTag =  $(this).val();
       location.href = selectedTag;
    });


   // collection page varinats images 

    $('.varianst_logoimage ul li').mouseover(function () {
       var variants_images =  $(this).attr('data_variants');
      $('.varianst_logoimage ul li').removeClass('variants_logo_hovers');
       $(this).addClass('variants_logo_hovers');
      // alert(variants_images);
       $(this).closest('.card-wrapper').find('.card__media img' ).attr("srcset", variants_images);
    });
  

$('.itg_variant_slider').slick({
  infinite: true,
  autoplay: false,
  loop:true,
  autoplaySpeed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="slick-prev"><svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><g><path d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"/></g></svg></div>',
    nextArrow: '<div class="slick-next"><svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <g> <path d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"/> </g> </g></svg></div>'
});

$('.blogs_head_toggle .toggles_open svg').click(function () {
  //alert();
  $(this).closest('.main-blog').toggleClass('blog_fillter');
  $(this).closest('.main-blog').find('.toggles_open').toggleClass('fillter_icons');
});  

$('.article_div_main  .toggles_open svg').click(function () {
  //alert();
 $(this).closest('.article_div_main').find('.itg_article_fillter').toggleClass('article_fillter');
   $(this).closest('.article_div_main').find('.toggles_open').toggleClass('fillter_icons');
}); 

  

  $(".product-grid-container .grid__item").hover(function(){

     $(document).find('.bottom_contenst').removeClass('bottom_contain');
     $(document).find(".varianst_logoimage").css({"opacity": "0", "height": "0", "padding-top": "0px"});
    
   
     if($(this).find('.product-card-wrapper').hasClass("findcolorgrid")){
        $(this).find('.varianst_logoimage').css({"opacity": "1", "height": "auto", "padding-top": "10px"});
        $(this).find('.bottom_contenst').addClass('bottom_contain');
     }
    
  });

  var findsize = $(document).find('#cus_select__select').attr('data-option');
  if((findsize == 'Size') || (findsize == 'size')){
    
      $(document).find("fieldset.js.product-form__input input").removeClass('disabled');
        var len =  $(document).find("fieldset.js.product-form__input").length;
          var sizeindex =  $('.product-form__input.optionname_size').attr('index');
          var option2 =  $('.product-form__input[index="2"]').find('input:checked').attr('value');
          var option3 =  $('.product-form__input[index="3"]').find('input:checked').attr('value');
        $('.product-form__input.optionname_size').find('input').each(function(){
          var value = $(this).attr('value');
          if(len == 2 ){
            var selectedValue = (value +' / '+option2);
          }else if(len == 3){
              var selectedValue = (value +' / '+option2 +' / '+option3 );
          }
         if( $(document).find('#cus_select__select option').hasClass(selectedValue)){
           $(this).removeClass("disabled");
          }else{
          $(this).addClass("disabled");  
         }
        });
    
 
      $(document).on('change','.product-form__input input',function() {
      var len =  $(document).find("fieldset.js.product-form__input").length;
      $(document).find("fieldset.js.product-form__input input").removeClass('disabled');
          var sizeindex =  $('.product-form__input.optionname_size').attr('index');
          var option2 =  $('.product-form__input[index="2"]').find('input:checked').attr('value');
          var option3 =  $('.product-form__input[index="3"]').find('input:checked').attr('value');
        $('.product-form__input.optionname_size').find('input').each(function(){
          var value = $(this).attr('value');
          if(len == 2 ){
            var selectedValue = (value +' / '+option2);
          }else if(len == 3){
              var selectedValue = (value +' / '+option2 +' / '+option3 );
          }
         if( $(document).find('#cus_select__select option').hasClass(selectedValue)){
           $(this).removeClass("disabled");
          }else{
          $(this).addClass("disabled");  
         }
        });
     });  
  }
  
   $(document).on('change','.product-form__input input',function() {
     var value = $(this).attr('value');
    $(this).closest('.product-form__input').find('.form__label .OptValue').html(value)
   });  
    var Sizevalue =  $('.product-form__input.optionname_size').find('input:checked').attr('value');
    var ColorValue =  $('.product-form__input.optionname_color').find('input:checked').attr('value');
    $('.product-form__input.optionname_size').find('.form__label .OptValue').html(Sizevalue);
    $('.product-form__input.optionname_color').find('.form__label .OptValue').html(ColorValue);
});

